export default __webpack_public_path__ + "static/04_V1@2x-6464b647322622c6d2434b5acfbd3236.png";